<template>
  <div class="tnm-container tnm-public-page tnm-event-list__page">
    <!-- Dynamisches Style-Tag für das customCss -->
    <component :is="'style'" v-if="activeCustomCss">
      {{ activeCustomCss }}
    </component>

    <div class="grid-container tnm-event-list__container">
      <div class="grid-x grid-margin-x grid-margin-y">
        <div v-for="event of compEvents" :key="event.id" class="tnm-event-list__card tnm-event-card cell large-6">
          <div class="grid-x full-height">
            <div class="tnm-event-list__date-panel tnm-left-cell cell medium-shrink large-shrink">
              <div class="grid-x full-height">
                <div class="tnm-event-list__day tnm-day-cell cell">
                  {{event.comp.day}}
                </div>
                <div class="tnm-event-list__month tnm-month-cell cell align-self-bottom">
                  {{event.comp.month}}
                </div>
              </div>
            </div>
            <div class="tnm-event-list__content tnm-right-cell cell medium-auto large-auto">
              <div class="grid-x" style="height:100%">
                <div class="tnm-event-list__title tnm-title-cell cell">
                  {{event.title}}
                  <span v-if="event.comp.isLive" class="tnm-event-list__live-badge tnm-live-badge">{{t('event_live_badge_text', 'LIVE')}}</span>
                </div>
                <div class="tnm-event-list__description tnm-descr-cell cell align-self-top" v-html="event.comp.description">
                </div>
                <div class="tnm-event-list__schedule tnm-date-cell cell align-self-bottom">
                  <div class="grid-x full-height">
                    <div class="cell auto align-self-bottom tnm-event-list__date-text">
                      {{event.comp.dateStr}} - {{event.comp.time}} {{t('event_card_time_suffix', 'Uhr')}}
                    </div>
                    <div class="cell auto align-right shrink align-self-bottom tnm-event-list__actions">
                      <router-link :to="{name: 'Event', params: {id: event.id}}" class="button nomargin small tnm-event-list__button" data-text-id="event_card_button_text">{{t('event_card_button_text', 'Mehr dazu')}}</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCustomText } from '../lib/custom-texts'
import '../styles/public-events.css'
import { getEventAvailability } from '../lib/event-availability'

let height;
const sendPostMessage = () => {
  // Sicherstellen, dass das Element existiert, bevor darauf zugegriffen wird
  const appElement = document.getElementById('app');
  if (appElement && height !== appElement.offsetHeight) {
    height = appElement.offsetHeight;
    if (window.parent && window.parent.postMessage) {
      window.parent.postMessage({
        frameHeight: height
      }, '*');
      console.log('Sent frameHeight:', height);
    }
  }
};

export default {
  name: 'Home',
  data() {
    return {
      state: this.$store.state, // Gehe davon aus, dass state.events hier reaktiv ist
      activeCustomCss: '',     // Hier speichern wir das CSS des ersten Events
      customTexts: {},
      currentTime: Date.now(),
      availabilityTimer: null
    };
  },
  async mounted() {
    console.log("route", this.$route);
    // Es ist besser, app.userId direkt im State zu ändern, falls es reaktiv sein soll,
    // oder es als lokale Variable zu verwenden, wenn es nur für diesen Request ist.
    // Für dieses Beispiel nehmen wir an, dass es für den getData Aufruf benötigt wird.
    const queryUserId = this.$route.query.id;
    // this.state.app.userId = queryUserId; // Wenn es im Store sein soll

    await this.getData(queryUserId); // userId an getData übergeben
    this.availabilityTimer = setInterval(() => {
      this.currentTime = Date.now()
      this.$nextTick(() => {
        sendPostMessage()
      })
    }, 30000)

    // Nachdem die Daten geladen wurden, das customCss extrahieren
    this.applyCustomCssFromEvents();

    // Es ist sicherer, sendPostMessage nach einer DOM-Aktualisierung aufzurufen
    this.$nextTick(() => {
      setTimeout(() => { // Der Timeout könnte immer noch nötig sein, falls CSS-Transitionen etc. Zeit brauchen
        sendPostMessage();
      }, 300); // 300ms ist relativ lang, vielleicht kann das optimiert werden
    });
  },
  computed: {
    compEvents() {
      if (!this.state.events || this.state.events.length === 0) {
        return [];
      }
      return this.state.events.map((originalEvent) => {
        const availability = getEventAvailability(originalEvent, this.currentTime)
        if (!availability.isVisibleInFeed) {
          return null
        }

        // Erstelle eine Kopie, um das Original im Store nicht direkt zu mutieren (gute Praxis)
        const event = { ...originalEvent, comp: {} };
        event.comp.isLive = availability.isLive

        let date = new Date(event.startDate);
        event.comp.day = date.toLocaleDateString('de-DE', { day: '2-digit', timeZone: 'Europe/Berlin' });
        event.comp.month = date.toLocaleString('de-DE', { month: 'short', timeZone: 'Europe/Berlin' });
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', timeZone: 'Europe/Berlin' };
        event.comp.dateStr = date.toLocaleDateString('de-DE', options);
        event.comp.time = date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Berlin' });
        if (event.comp.day.length === 1) event.comp.day = '0' + event.comp.day;

        if (event.description) {
          event.comp.description = event.description.replace(/<(.|\n)*?>/g, '');
          event.comp.description = event.description;
          if (event.comp.description.length > 180) {
            event.comp.description = event.comp.description.substr(0, 180) + '...';
          }
        } else {
          event.comp.description = '';
        }
        return event;
      }).filter(Boolean);
    }
  },
  methods: {
    async getData(userIdForRequest) { // userId als Parameter annehmen
      let data;
      try {
        // Verwende die übergebene userId für den Request
        data = await this.$http.get(this.state.app.apiUrl + '/event/', {
          params: { userId: userIdForRequest, "$sort[startDate]": 1 }
        });
        // Weise die Daten dem Store/State zu
        // Stelle sicher, dass dies eine reaktive Zuweisung ist, falls this.state.events
        // nicht bereits korrekt reaktiv im Store initialisiert wurde.
        // Vue.set oder this.$store.commit wird für Vuex benötigt.
        // Wenn this.state direkt vom Vue-Instanz-data kommt und events ein Array ist, ist push/splice oder Neuzuweisung ok.
        this.$store.state.events = data.data.data ? [...data.data.data] : []; // Sicherstellen, dass es ein Array ist und reaktiv bleibt

      } catch (err) {
        console.error('Error fetching events:', err);
        this.$store.state.events = []; // Im Fehlerfall leeren
      }
      console.log('Fetched events:', this.state.events);
    },
    applyCustomCssFromEvents() {
      if (this.state.events && this.state.events.length > 0 && this.state.events[0].customCss) {
        this.activeCustomCss = this.state.events[0].customCss;
        console.log('Applied custom CSS:', this.activeCustomCss);
      } else {
        this.activeCustomCss = ''; // Kein CSS oder keine Events
      }
      this.customTexts = this.state.events && this.state.events.length > 0 && this.state.events[0].customTexts
        ? this.state.events[0].customTexts
        : {}
    },
    t(id, fallback, variables = {}) {
      return getCustomText(this.customTexts, id, fallback, variables)
    }
  },
  watch: {
    // Beobachte Änderungen an den Events im Store, falls sie von anderswo aktualisiert werden könnten
    // und wende das CSS entsprechend erneut an.
    'state.events': {
      handler: 'applyCustomCssFromEvents',
      deep: true // Notwendig, wenn sich customCss innerhalb eines Event-Objekts ändern könnte
                 // oder wenn die Array-Referenz gleich bleibt, aber der Inhalt sich ändert.
                 // Wenn state.events immer komplett neu zugewiesen wird, ist deep nicht zwingend.
    }
  },
  beforeDestroy () {
    if (this.availabilityTimer) {
      clearInterval(this.availabilityTimer)
    }
  }
}
</script>
